import React from "react";

const Layout = ({ children }) => {
  return <div className='bg-gray-50 h-full md:h-screen'>{children}</div>;
};

export default Layout;
